import React from "react";
import { fireEvent, render, screen, waitFor } from "@testing-library/react";
import "@testing-library/jest-dom";
import CopyPublishedLink, { publishedCanvasUrl } from "./CopyPublishedLink";

describe("CopyPublishedLink", () => {
  it("builds a stable direct link and lets admins copy it", async () => {
    const writeText = jest.fn().mockResolvedValue(undefined);
    Object.defineProperty(navigator, "clipboard", {
      configurable: true,
      value: { writeText },
    });
    render(<CopyPublishedLink canvasId="canvas-1" isPublished isAdmin />);
    fireEvent.click(
      screen.getByRole("button", { name: "Copy published link" }),
    );
    await waitFor(() =>
      expect(writeText).toHaveBeenCalledWith(publishedCanvasUrl("canvas-1")),
    );
    expect(await screen.findByRole("status")).toHaveTextContent(
      "Published link copied",
    );
  });

  it.each([
    [false, true],
    [true, false],
  ])(
    "hides the control for isAdmin=%s, isPublished=%s",
    (isAdmin, isPublished) => {
      render(
        <CopyPublishedLink
          canvasId="canvas-1"
          isPublished={isPublished}
          isAdmin={isAdmin}
        />,
      );
      expect(
        screen.queryByRole("button", { name: "Copy published link" }),
      ).toBeNull();
    },
  );
});
